// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".fs-room-selection-alert {\n  --background: var(--ion-card-background);\n}", "",{"version":3,"sources":["webpack://./src/components/TipsModal/styles.scss"],"names":[],"mappings":"AAAA;EACE,wCAAA;AACF","sourcesContent":[".fs-room-selection-alert {\n  --background: var(--ion-card-background);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
